import React, { FC, useContext } from 'react';
import ListItem from "@mui/material/ListItem/ListItem";
import IconButton from "@mui/material/IconButton/IconButton";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Tooltip from "@mui/material/Tooltip/Tooltip";
import { RouteConfig } from "../../config/RouteConfig";
import { Link } from "react-router-dom";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { Notification } from '../../models/users/Notification';
import { markUserNotificationAsRead } from '../../actions/user/NotificationActions';
import { LanguageProp} from '../../config/LanguageConfig';
import {LanguageContext} from "../../config/ContextConfig";

/**
 * typescript
 */
interface NotificationListItemProps extends Partial< LanguageProp > {
    notification: Notification
    closeDrawer(): void
    markAsRead: typeof markUserNotificationAsRead 
}

/**
 *
 * @constructor
 */
const NotificationListItem: FC< NotificationListItemProps > = ({  notification, markAsRead, closeDrawer }) => {
    const language = useContext( LanguageContext );

    const getNotification = () => {
        return (
            <div>
                <div>
                    <Tooltip title={language.projects.jumpToProjectWithArgs( `${notification.project.projectNumber} - ${notification.project.shortDescription}` )}>
                            <div>
                                { `${notification.project.projectNumber} - ${notification.project.shortDescription}` }
                            </div>
                    </Tooltip>
                </div>
                <div style={{ padding: 5+'px' }}>
                    {notification.message}
                </div>
            </div>
        )
    };

    return (
        <ListItem>
            <div style={{ 'display': 'flex' }}>
                <Tooltip title={language.common.markAsRead.tooltipText}>
                    <IconButton
                        aria-haspopup="true"
                        aria-label={language.common.markAsRead.tooltipText}
                        color="primary"
                        onClick={() => markAsRead( notification.id.rawValue )}
                    >
                        <RemoveRedEyeIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={language.common.jumpToEntry.tooltipText}>
                    <Link to={
                        typeof RouteConfig.projectLog.routes.thread.link !== 'undefined'
                        ? RouteConfig.projectLog.routes.thread.link(
                            notification.project.projectId,
                            notification.entry.projectLogEntryId.rawValue,
                            notification.entry.projectLogId.rawValue
                            )
                        : null
                    }>
                        <IconButton
                            aria-haspopup="true"
                            aria-label={language.common.jumpToEntry.tooltipText}
                            color="primary"
                            onClick={() => closeDrawer()}
                        >
                            <ArrowRightAltIcon />
                        </IconButton>
                    </Link>
                </Tooltip>
                {getNotification()}
            </div>
        </ListItem>
    );
};

export default NotificationListItem;